window.bz_navbar_module = angular.module('bzNavbarModule', ['bzUserModule'])
